<!-- Header Structure -->
<template>
  <div class="app-header">
    <v-toolbar
      app
      fixed
      :flat="embed"
      :color="isForBizgain ? 'primary' : activeHeaderFilter.class"
      v-if="$vuetify.breakpoint.smAndDown && !($route.name === 'richMediaAdPreview')"
    >
      <div
        class="align-items-center navbar-left"
        :class="{
          'd-custom-flex': isAppLayout,
          'logo-container-flex': !isAppLayout
        }"
      >
        <v-toolbar-side-icon
          class="absolute-position-icon v-step-0"
          :class="{ 'white--text' : isForBizgain }"
          icon
          large
          @click.stop="toggleSidebarDrawer"
          v-show="isAppLayout && !sidebarDrawer&&!(embed)"
        />
        <v-layout align-center v-if="!isAppLayout">
          <v-flex xs2>
            <v-layout justify-start class="header-actions">
              <call-back-tile
                class="chat-panel"
                :show-only-icon="true"
                @openCallBackWindow="openCallbackDailog()"
              />
            </v-layout>
          </v-flex>
          <v-flex xs4 shrink offset-xs2>
            <v-layout
              justify-center
              class="header-actions"
              v-if="appLogo"
            >
              <app-logo
                :height="28"
              />
            </v-layout>
          </v-flex>

          <v-flex xs4>
            <v-layout justify-end class="header-actions" v-if="!(embed)">
              <user-block v-if="user && enableUserBlock" :show-only-avatar="true" />
            </v-layout>
          </v-flex>
        </v-layout>
        <div v-else style="padding-left: 30px">
          <v-breadcrumbs
            :items="breadcrumbs"
            v-if="!(embed)"
            light
          >
            <v-icon slot="divider">
              chevron_right
            </v-icon>
            <template slot="item" slot-scope="props">
              <a
                :href="props.item.href"
                v-if="!headerAddtionalInfo"
                class="breadcrumb-text fw-bold"
                :class="{'white--text' : isForBizgain}"
              >
                {{
                  props.item.text
                }}
              </a>
              <span class="breadcrumb-text fw-bold" v-else> {{ headerAddtionalInfo }} </span>
            </template>
          </v-breadcrumbs>
        </div>
      </div>
    </v-toolbar>
  </div>
</template>
<style scoped>
.sidebar-dividers {
  border-color: rgb(120, 120, 120) !important;
}
.sidebar-logo > .v-list__tile {
  padding-left: 10px;
}
.absolute-position-icon {
  position: absolute;
  top: 0px;
  left: 0px;
}
.logo-container-flex {
  display: flex;
  flex: 1 0 auto;
  width: 100%;
}
</style>
<style lang="scss">
.header-actions {
  .v-list__tile {
    padding: 0.1rem;
    .v-list__tile__action {
      min-width: 0;
    }
    .v-list__tile__avatar {
      min-width: 0 !important;
    }
  }
}
.absolute-position-icon {
  @media screen and (orientation: landscape) {
    margin: 2px 0px !important;
  }
}
.app-header {
  .v-toolbar--fixed{
    z-index: 10;
  }
}
</style>
<script>
import AppConfig from 'Constants/AppConfig';
import { getCurrentAppLayout } from 'Helpers/helpers';
import { mapGetters, mapActions } from 'vuex';
import UserBlock from 'Components/User/TheUserBlock';
import CallBackTile from 'Components/CallbackDialog/CallBackTile';
import { Stores, StoreTypes } from 'Constants/storeTypes';
import AppLogo from 'Components/AppLogo/TheAppLogo';
import {
  VToolbar,
  VBreadcrumbs,
  VToolbarSideIcon,
  VLayout,
  VFlex,
  VIcon
} from 'vuetify/lib';

export default {
  props: {
    horizontal: {
      default: false,
      type: Boolean
    },
    embed: { type: Boolean, default: false }
  },
  data() {
    return {
      sidebarImages: '', // sidebar background images
      enableDefaultSidebar: false,
      appLogo: AppConfig.appLogo,
      chatWindowToken: AppConfig.chatWindowToken,
      chatWindowUrl: AppConfig.chatWindowUrl,
      storeTypes: StoreTypes,
      stores: Stores
    };
  },
  mounted() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.setOuterNavWidth(250);
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'activeHeaderFilter',
      'backgroundImage',
      'selectedSidebarBgImage',
      'backgroundImage',
      'sidebarDrawer',
      'roimaticFlavour',
      'isForCreativeBuilder',
      'headerAddtionalInfo',
      'enableUserBlock',
      'portal',
      'isForBizgain'
    ]),
    breadcrumbs() {
      var self = this;
      return this.$breadcrumbs.map(breadcrumb => ({
        text: self.$t(breadcrumb.meta.breadcrumb)
      }));
    },
    isAppLayout() {
      return this.$route.path.startsWith('/app') || this.$route.name.startsWith('portal');
    }
  },
  methods: {
    ...mapActions(['toggleSidebarDrawer', 'setOuterNavWidth']),
    getMenuLink(link) {
      return '/' + getCurrentAppLayout(this.$router) + link;
    },
    openCallbackDialog() {
      this.$refs.callbackDialog.updateState();
    }
  },
  components: {
    VBreadcrumbs,
    VToolbar,
    VToolbarSideIcon,
    VLayout,
    VFlex,
    UserBlock,
    VIcon,
    CallBackTile,
    AppLogo
  }
};
</script>